import BaseComponent from "../../../baseComponent.js";
import styles from "./data-profile-fields.scss";

class Field extends BaseComponent {
  constructor(props) {
    super(props);
    let _this = this;
    this.state = {
      id: _this.props.field.persistenceId,
      name: _this.props.field.name,
      fieldId: _this.props.field.fieldId,
      valueType: _this.props.field.valueType,
      maxLength: _this.props.field.maxLength,
      error: {
        name: _this.props.field.error[0].name,
        id: _this.props.field.error[0].id,
        valueType: _this.props.field.error[0].valueType,
        maxLength: _this.props.field.error[0].maxLength
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.field.error !== 'undefined') {
      this.setState({
        id: nextProps.field.persistenceId,
        name: nextProps.field.name,
        fieldId: nextProps.field.fieldId,
        valueType: nextProps.field.valueType,
        maxLength: nextProps.field.maxLength,
        error: {
          name: nextProps.field.error[0].name,
          id: nextProps.field.error[0].id,
          valueType: nextProps.field.error[0].valueType,
          maxLength: nextProps.field.error[0].maxLength
        }
      });
    }
    else {
      this.setState({
        id: nextProps.field.persistenceId,
        name: nextProps.field.name,
        fieldId: nextProps.field.fieldId,
        valueType: nextProps.field.valueType,
        maxLength: nextProps.field.maxLength,
      });
    }
  }

  addField() {
    // TODO: validation
    if (this.state.name.length > 0 && this.state.fieldId.length > 0 && this.state.valueType != "") {
      this.state.valueType = parseInt(this.state.valueType);
      this.state.maxLength = this.state.valueType === 8 ? parseInt(this.state.maxLength) : null;
      this.props.addField(this.state);
    }
  }

  removeField() {
    this.props.removeField(this.state);
  }

  handleChange(event, propertyName) {
    let state = {};
    state = this.state;
    state[propertyName] = event.target.value;
    if (this.state.valueType != "8") {
      this.state.maxLength = null;
    }
    if (this.state.valueType == "8" && this.state.maxLength != null) {

      let maxLength = this.state.maxLength;
      if (maxLength.length > 0) {
        this.state.maxLength = parseInt(this.state.maxLength);
        if (this.state.maxLength == "NaN") {
          this.state.maxLength = "";
        }
      }
    }
    this.setState(state);
    this.callbackParent();
  }

  callbackParent() {
    this.props.callBackFunction(this.state);
  }

  render() {
    let button;
    let maxLengthInput = <div className="na">N/A</div>;

    if (this.props.isLastItem) {
      button = <i className="material-icons" onClick={() => this.props.onAddBtnClicked()}>add_circle_outline</i>;
    } else {
      button =
        <i className="material-icons field-remove-btn" onClick={() => this.removeField()}>remove_circle_outline</i>;
    }

    if (this.state.valueType === "8") {
      if (this.state.maxLength == null) {
        this.state.maxLength = "";
      }
      maxLengthInput = <input type="text" placeholder="Enter max length" value={this.state.maxLength}
                              onChange={e => this.handleChange(e, "maxLength") }/>;
    }

    return (
      <li className={["collection-item data-profile-field", styles.field].join(" ")}>
        <div>
          <div className={this.state.error.name}>
            <input type="text" placeholder="Enter field name" value={this.state.name}
                   onChange={e => this.handleChange(e, "name")}/>
          </div>
        </div>
        <div>
          <div className={this.state.error.id}>
            <input type="text" placeholder="Enter field id" value={this.state.fieldId}
                   onChange={e => this.handleChange(e, "fieldId")}/>
          </div>
        </div>
        <div>
          <div className={this.state.error.valueType}>
            <select value={this.state.valueType} onChange={e => this.handleChange(e, "valueType") }>
              <option value="" disabled>Type
              </option>
              <option value="1">DOUBLE</option>
              <option value="2">FLOAT</option>
              <option value="3">BYTE</option>
              <option value="4">SHORT</option>
              <option value="5">INT</option>
              <option value="6">LONG</option>
              <option value="7">BOOLEAN</option>
              <option value="8">STRING</option>
            </select>
          </div>
        </div>
        <div>
          <div className={this.state.error.maxLength}>
            {maxLengthInput}
          </div>
        </div>
        <div className="action-btn">
          {button}
        </div>
      </li>
    )
  }
}

export default class CreateDataProfileFields extends BaseComponent {

  callbackParent(value) {
    this.props.onChanges(value);
  }

  render() {
    var lengthOfArray = this.props.fields;
    var fields = [];
    var field = this.props.fields;

    for (let i = 0; i < lengthOfArray.length; i++) {
      fields.push(<Field field={field[i]} removeField={this.props.removeField} onChanged={this.props.onFieldChanged}
                         onAddBtnClicked={this.props.onAddBtnClicked} isLastItem={i === this.props.fields.length - 1}
                         callBackFunction={this.callbackParent} persistenceId={this.props.fields.persistenceId} key={i}/>);
    }

    return (
      <ul className="collection">
        <li className={["collection-item", styles.field].join(" ")}>
          <div className="header">Field Name</div>
          <div className="header">Field Id</div>
          <div className="header">Field Type</div>
          <div className="header">Max Length</div>
          <div style={{width: "30px"}}></div>
        </li>
        {fields}
      </ul>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/data-bank/create/dataprofile/createDataProfileFields.jsx